import type { BossReward } from '../types/reward.types';

/**
 * One-time non-spell grants delivered on the player's **first kill** of a boss
 * / mini-boss (major / minor trinket / sketch), unlocked directly with their
 * showcase. The **spell** reward is NOT here: it drops as a grimoire loot entry
 * on the monster's loot table (`guaranteedOnFirstKill`, cf. `monsters.config.ts`
 * + `MonsterEntity.death`).
 *
 * Indexed by `monster.configId` (bossId = configId, cf. `MonsterEntity.death()`).
 * cf. docs/game-design/loot.md (vision).
 */
export const BOSS_REWARDS: Record<string, BossReward> = {
  shoebill: {
    bossId: 'shoebill',
    grantsMinor: 'gloom-charm',
    grantsSketch: 'sketch-sadness',
  },

  medusa: {
    bossId: 'medusa',
    grantsMinor: 'dread-charm',
    grantsSketch: 'sketch-fear',
  },

  dragon: {
    bossId: 'dragon',
    grantsSketch: 'sketch-anger',
  },

  kitsune: {
    bossId: 'kitsune',
    grantsMinor: 'flash-charm',
    grantsSketch: 'sketch-surprise',
  },

  jinn: {
    bossId: 'jinn',
    grantsSketch: 'sketch-joy',
  },

  parasite: {
    bossId: 'parasite',
    grantsMinor: 'rot-charm',
    grantsSketch: 'sketch-disgust',
  },
};
